module.exports = __webpack_public_path__ + "static/media/lpc.ef665be2.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/ContactUs/lpc.png
// module id = 50
// module chunks = 0